<template>
  <div class="main_bg">
    <img class="main_img" src="@/assets/404_images/main.png" alt="404">

    <p class="title">404 Error</p>
    <div class="des">
      <p>Sorry, the page you are looking for does not exist. </p>
      <p>Try to check the URL for errors and then press the refresh button on the browser</p>
      <p>or try to find something else in our application.</p>
    </div>
    <div class="btn" @click="goHome">Home Page</div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  computed: {
    message() {
      return "Page not found!";
    },
  },
  methods: {
    goHome() {
      if (this.$store.getters.roles === 3) {
        this.$router.push("/wellManagement/myWells");
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main_bg {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 80px;
  background: url('~@/assets/404_images/bg.png');
  background-size: 100% 100%;
  text-align: center;
}

.main_img {
  width: 37%;
  /* height: 520px; */
  margin-top: 100px;
}

.title {
  font-size: 36px;
  font-family: HurmeGeometricSans2-Bold, HurmeGeometricSans2;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 47px;
  margin-top: 43px;
}

.des {
  font-size: 16px;
  font-family: PlusJakartaDisplay-Regular, PlusJakartaDisplay;
  font-weight: 400;
  color: #DCE0E7;
  line-height: 22px;
  margin-top: 12px;
}

.btn {
  width: 240px;
  height: 48px;
  background: linear-gradient(264deg, #225BFC 0%, #001A49 100%);
  border-radius: 14px;
  font-size: 18px;
  font-family: HurmeGeometricSans2-SemiBold, HurmeGeometricSans2;
  font-weight: 600;
  color: #F1F3F8;
  text-align: center;
  line-height: 48px;
  margin: 0 auto;
  margin-top: 40px;
  cursor: pointer;
}
</style>
